import type { ValidationConfig } from "@/components/units/MediaUploader/mediaStore";

import type { IProperty } from "../branches/types";
import type { BrandMenuGet } from "./menuTypes";

export interface SocialLink {
  type: string;
  url: string;
}

interface BrandInfo {
  id?: string;
  email?: string | null;
  active?: boolean;
  country: string;
}

interface CommonBrandInfo {
  VAT: string;
  googleBusinessId: string;
  legalEntityId: string;
  legalEntityName?: string;
  /** ISO code, e.g. "SAR". This is the value the currency dropdown submits. */
  currency: string;
  /** Localized name for display, e.g. "Saudi Riyal". Null if the code is unknown. */
  currencyName?: string | null;
  commercialRegistration: string;
  phone?: string | null;
  websiteUrl?: string | null;
  socialLinks?: SocialLink[];
  mediaItemId?: string;
  logoUrl?: string | null;
}

export interface IBrand extends BrandInfo, CommonBrandInfo {
  nameEn: string;
  nameAr: string;
  descriptionEn?: string;
  descriptionAr?: string;
  groupId?: string;
  groupName?: string;
  groupActive?: boolean;
  groupCountry?: string;
  groupCurrency?: string;
  properties?: IProperty[];
}

export interface IBrandInfo extends BrandInfo {
  referenceNumber: string;
  name: string;
  branchesCount: number;
  legalEntityName?: string;
  legalEntityId?: string;
  createdAt?: string;
}

export type BranchesInBrand = {
  branchId: string;
  branchName: string;
  cityName?: string;
  active?: boolean;
};

export interface IBrandGetById extends IBrand {
  referenceNumber: number;
  branches: BranchesInBrand[];
  menu?: BrandMenuGet | null;
  properties?: IProperty[];
}

export type IBrandPatchPayload = Partial<Omit<IBrand, "id">> & {
  properties?: string[];
};

export type BrandId = string;

export const BRAND_LOGO_ACCEPTED_IMAGE_TYPES = {
  "image/jpeg": [".jpeg", ".jpg"],
  "image/png": [".png"],
  "image/gif": [".gif"],
  "image/webp": [".webp"],
} as const;

export const BRAND_LOGO_ACCEPTED_TYPES = {
  ...BRAND_LOGO_ACCEPTED_IMAGE_TYPES,
  "image/svg+xml": [".svg"],
} as const;

export const BrandLogoMediaValidation: ValidationConfig = {
  image: {
    acceptedMimeTypes: Object.keys(BRAND_LOGO_ACCEPTED_IMAGE_TYPES),
    maxSize: 3 * 1024 * 1024,
    minSize: 1000,
    dimensionConstraints: {
      minWidth: 500,
      minHeight: 500,
    },
  },
  vector: {
    acceptedMimeTypes: ["image/svg+xml"],
    maxSize: 3 * 1024 * 1024,
    minSize: 1000,
  },
  limits: {
    maxImages: 1,
  },
};
